/**
 *
 * @module entry
 * @desc {SDK.Services.Account} entry point.
 *
 */

import Account from './account';
import AccountClient from './accountClient';
import AccountClientConfiguration from './accountClientConfiguration';
import AccountClientEndpoint from './accountClientEndpoint';
import AccountGrant from './accountGrant';
import Identity from './identity';
import UserProfile from './userProfile';
import CreateAccountResult from './createAccountResult';
import DeleteUserProfileResult from './deleteUserProfileResult';
import UpdateUserProfileResult from './updateUserProfileResult';

/**
 *
 * @typedef SDK.Services.Account
 * @type {Object}
 *
 * @property {Account} Account
 * @property {AccountClient} AccountClient
 * @property {AccountClientConfiguration} AccountClientConfiguration
 * @property {AccountClientEndpoint} AccountClientEndpoint
 * @property {AccountGrant} AccountGrant
 * @property {Identity} Identity
 * @property {UserProfile} UserProfile
 * @property {CreateAccountResult} CreateAccountResult
 * @property {DeleteUserProfileResult} DeleteUserProfileResult
 * @property {UpdateUserProfileResult} UpdateUserProfileResult
 *
 */

/**
 *
 * @type {SDK.Services.Account}
 *
 */
export default {

    Account,
    AccountClient,
    AccountClientConfiguration,
    AccountClientEndpoint,
    AccountGrant,
    Identity,
    UserProfile,
    CreateAccountResult,
    DeleteUserProfileResult,
    UpdateUserProfileResult

};



// WEBPACK FOOTER //
// ./src/services/account/entry.js